import Dialog from "../1. Core/Controls/Dialog/Dialog";
import {HighlightRow, IBattle, MMAEvent} from "../10. Battle/types";
import Delegate from "../1. Core/Delegate";
import TextField from "../1. Core/Controls/TextField/TextField";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import TimeEdit, {TimeEditMode} from "../1. Core/Controls/TimeEdit/TimeEdit";
import WorldTimeEdit from "../1. Core/Controls/TimeEdit/WorldTimeEdit";
import NumField from "../1. Core/Controls/TextField/NumField";
import Select from "../1. Core/Controls/Select/Select";


export default class EditMMAEventDialog extends Dialog {

	private _Event: MMAEvent
	private _Battle: IBattle;
	private EvSaved: Delegate;
	private _time: TimeEdit;
	private _wtime: WorldTimeEdit;
	private _actionField: TextField;
	private _answerField: TextField;
	private _zoneField: TextField;
	private _prevSeconds: NumField;
	private _nextSeconds: NumField;
	//private _actionAthlete: NumField;
	//private _answerAthlete: NumField;
	private actionSelect: Select;
	private _groundStart: TimeEdit;
	private _groundEnd: TimeEdit;
	private _grappleStart: TimeEdit;
	private _grappleEnd: TimeEdit;


	constructor(settings: any)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this._Battle = null;
		this._Event = null;
		this.EvSaved = new Delegate();
		super._initFields(settings);
		this._Caption = NP.RM.getString('EditEvent');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._AutoDestroy = true;
	}

	_render()
	{
		super._render();


		// this._actionAthlete = new NumField({
		// 	FloatingLabel: 'ActionAthleteId',
		// 	ParentNode: this._contentNode,
		// 	Value: this._Event.ActionAthleteId
		// })

		this.actionSelect = new Select({
			FloatingLabel: 'Action Athlete',
			ParentNode: this._contentNode,
			Items: [
				{Content: this._Battle.RedName, Value: this._Battle.Red},
				{Content: this._Battle.BlueName, Value: this._Battle.Blue}
			],
			Value: this._Event.ActionAthleteId
		})

		// this._answerAthlete = new NumField({
		// 	FloatingLabel: 'AnswerAthleteId',
		// 	ParentNode: this._contentNode,
		// 	Value: this._Event.AnswerAthleteId
		// })

		this._actionField = new TextField({
			FloatingLabel: NP.RM.getString('Action'),
			Data: 'Action',
			ParentNode: this._contentNode,
			Value: this._Event.Action
		})

		this._answerField = new TextField({
			FloatingLabel: 'Answer',
			ParentNode: this._contentNode,
			Value: this._Event.Answer
		})

		this._zoneField = new TextField({
			FloatingLabel: 'Zone',
			ParentNode: this._contentNode,
			Value: this._Event.Zone
		})

		this._time = new TimeEdit({
			FloatingLabel: 'Time',
			Width: 379,
			ParentNode: this._contentNode,
			Mode: TimeEditMode.Full,
			Value: this._Event.Time,
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._wtime.incrementValue(e.IsPlus, false)
			}
		})


		this._wtime = new WorldTimeEdit({
			FloatingLabel: NP.RM.getString('WorldTime'),
			Width: 379,
			ParentNode: this._contentNode,
			Value: this._Event.ActionTS,
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._time.incrementValue(e.IsPlus, false)
			}
		})


		this._groundStart = new TimeEdit({
			FloatingLabel: 'Ground Start',
			Width: 150,
			ParentNode: this._contentNode,
			Mode: TimeEditMode.Full,
			Value: this._Event.GroundStart,
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._groundStart.incrementValue(e.IsPlus, false)
			}
		})

		this._groundEnd = new TimeEdit({
			FloatingLabel: 'Ground end',
			Width: 150,
			ParentNode: this._contentNode,
			Mode: TimeEditMode.Full,
			Value: this._Event.GroundEnd,
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._groundEnd.incrementValue(e.IsPlus, false)
			}
		})


		this._grappleStart = new TimeEdit({
			FloatingLabel: 'Grapple Start',
			Width: 150,
			ParentNode: this._contentNode,
			Mode: TimeEditMode.Full,
			Value: this._Event.GrappleStart,
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._grappleStart.incrementValue(e.IsPlus, false)
			}
		})

		this._grappleEnd = new TimeEdit({
			FloatingLabel: 'Grapple end',
			Width: 150,
			ParentNode: this._contentNode,
			Mode: TimeEditMode.Full,
			Value: this._Event.GrappleEnd,
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._grappleEnd.incrementValue(e.IsPlus, false)
			}
		})


		let info = (this._Event as HighlightRow).TimeInfo;

		if (info)
		{
			this._prevSeconds = new NumField({
				ParentNode: this._contentNode,
				Min: 0,
				Max: 50,
				Width: 190,
				SpinEdit: true,
				Value: info.PrevSeconds,
				FloatingLabel: NP.RM.getString('PrevSec')
			});

			this._nextSeconds = new NumField({
				ParentNode: this._contentNode,
				Min: 0,
				Max: 50,
				Width: 190,
				SpinEdit: true,
				Value: info.NextSeconds,
				FloatingLabel: NP.RM.getString('NextSec')
			});
		}


		this._contentNode.style.overflowX = 'hidden'
	}


	async _onOkButtonClick()
	{
		if (this._Event.EventOrder)
		{
			if (this.actionSelect.getValue() != this._Event.ActionAthleteId)
			{
				let a = this._Event.ActionAthleteId;
				this._Event.ActionAthleteId = this.actionSelect.getValue()
				this._Event.AnswerAthleteId = a;
			}
		}
		else
		{
			this._Event.ActionAthleteId = this.actionSelect.getValue()
			this._Event.AnswerAthleteId = this._Event.ActionAthleteId == this._Battle.Red ? this._Battle.Blue : this._Battle.Red;
		}


		this._Event.Action = this._actionField.getValue();
		this._Event.Zone = this._zoneField.getValue();
		this._Event.Answer = this._answerField.getValue();
		this._Event.Time = this._time.getValue();
		this._Event.ActionTS = this._wtime.getValue()

		this._Event.GrappleStart = this._grappleStart.getValue() == '00:00:00' ? null : this._grappleStart.getValue();
		this._Event.GrappleEnd = this._grappleEnd.getValue() == '00:00:00' ? null : this._grappleEnd.getValue();

		this._Event.GroundStart = this._groundStart.getValue() == '00:00:00' ? null : this._groundStart.getValue();
		this._Event.GroundEnd = this._groundEnd.getValue() == '00:00:00' ? null : this._groundEnd.getValue();

		let info = (this._Event as HighlightRow).TimeInfo;
		if (info)
		{
			info.NextSeconds = this._nextSeconds.getValue();
			info.PrevSeconds = this._prevSeconds.getValue();
		}

		await this.updateEvent(this._Event);

		this.EvSaved.fire(this);
		this.hide();
	}

	async updateEvent(ev: MMAEvent)
	{
		if (ev.Zone == '')
			ev.Zone = null;

		if (ev.EventOrder)
			await ServerAPI.post("/mma/event", ev);
		else
			await ServerAPI.post(`/mma/add-event?isRed=${ev.ActionAthleteId == this._Battle.Red}`, ev);

		for (let key in ev)
		{
			this._Event[key] = ev[key]
		}
	}
}